// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getCssUnitField from "@store/Framework/Common/Fields/Toolkit/cssUnit";
import getSpacingPresetField, { spacingPresetOptions } from "@store/Framework/Common/Fields/Toolkit/spacingPreset";
import { defaultBorderProps } from "@store/Library/Components/Toolkit/Block/defaultProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";
import { css, useTheme } from "styled-components";

const enum fields {
    spacing = "spacing",
    // Foundation Removed presetSpacing - had to keep the name of the field to prevent breaking changes
    customSpacing = "customSpacing",
    showHorizontalRule = "showHorizontalRule",
}

/* Starter Custom Code - Start */
const presetSpacingField = getSpacingPresetField(fields.spacing, { showCustom: true }); // Foundation Custom Code
const customSpacingField = getCssUnitField(fields.customSpacing);
/* Starter Custom Code - End */

interface Props extends WidgetProps {
    fields: {
        [fields.spacing]: string; // Foundation Custom Code
        [fields.customSpacing]: string;
        [fields.showHorizontalRule]: boolean;
    };
}

export interface SpacerStyles {
    horizontalRule?: InjectableCss;
}

export const spacerStyles: SpacerStyles = {
    horizontalRule: {
        css: css`
            margin: 0;
            border: 0;
            border-top: ${defaultBorderProps.width} ${defaultBorderProps.type} ${getColor(defaultBorderProps.color)};
        `,
    },
};

const Spacer: FC<Props> = ({ fields: { spacing /* Foundation Custom Code */, customSpacing, showHorizontalRule } }) => {
    const theme = useTheme();

    /* Foundation Custom Code - Start */
    const space = useMemo(() => {
        return presetSpacingField.parse(spacing, theme) || customSpacingField.parse(customSpacing);
    }, [theme, spacing, customSpacing]);
    /* Foundation Custom Code - End */

    const styles = useMemo(() => {
        return mergeProps<SpacerStyles>(spacerStyles, {
            horizontalRule: {
                css: css`
                    ${!showHorizontalRule ? "border: 0;" : null}
                    /* Foundation Custom Code */
                    ${breakpointValues(space, ["margin-top", "margin-bottom"])}
                `,
            },
        });
    }, [spacerStyles, spacing, showHorizontalRule]);

    return <StyledWrapper as="hr" aria-hidden="true" {...styles.horizontalRule} />;
};

const widgetModule: WidgetModule = {
    component: Spacer,
    definition: {
        group: "Basic",
        displayName: "Spacer",
        icon: "arrows-from-line",
        fieldDefinitions: [
            {
                ...presetSpacingField.definition,
                fieldType: "Contextual",
            },
            {
                ...customSpacingField.definition,
                fieldType: "Contextual",
                isVisible: x => x.fields[fields.spacing] === spacingPresetOptions.custom.id,
            },
            {
                name: fields.showHorizontalRule,
                displayName: "Show Horizontal Rule",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
        ],
    },
};

export default widgetModule;
